export default __webpack_public_path__ + "static/media/pl.d13a2b5f.svg";